import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "mcq-mmcq"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  key: 0,
  style: {
    "font-weight": "700"
  }
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "question"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  class: "answer"
};
const _hoisted_8 = {
  style: {
    "display": "flex",
    "align-items": "self-start"
  }
};
const _hoisted_9 = {
  class: "menu"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  key: 2
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [$props.questionInfo.skill == 'S1' || $props.questionInfo.skill == 'S2' ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString($props.questionInfo.itemName), 1)) : _createCommentVNode("", true), _createElementVNode("p", {
    innerHTML: $props.questionInfo.itemInstruction
  }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "question-text",
    innerHTML: $setup.itemText
  }, null, 8, _hoisted_6), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.questionInfo.questionGroupList, (questionItem, questionIndex) => {
    return _openBlock(), _createElementBlock("div", {
      class: "answer-item",
      key: 'que' + questionIndex
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(questionIndex + $props.questionInfo.menu), 1), questionItem.questionList[0].questionStem.split(' ').length > 2 ? (_openBlock(), _createElementBlock("p", {
      key: 0,
      style: {
        "flex": "1"
      },
      class: "questionStem",
      innerHTML: questionItem.questionList[0].questionStem
    }, null, 8, _hoisted_10)) : _createCommentVNode("", true)]), questionItem.questionMethod == 'mcq' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionItem.choiceList, (answerItem, answerIndex) => {
      return _openBlock(), _createBlock(_component_el_radio, {
        key: 'answer' + answerIndex,
        modelValue: $setup.answer[questionItem.questionList[0].questionId],
        "onUpdate:modelValue": $event => $setup.answer[questionItem.questionList[0].questionId] = $event,
        label: String.fromCharCode(65 + answerIndex),
        size: "large",
        onChange: $setup.setAnswer
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(String.fromCharCode(65 + answerIndex)) + ". ", 1), _createElementVNode("span", {
          innerHTML: answerItem.choiceText
        }, null, 8, _hoisted_12)]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "label", "onChange"]);
    }), 128))])) : questionItem.questionMethod == 'mmcq' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_checkbox_group, {
      max: 3,
      modelValue: $setup.answer[questionItem.questionList[0].questionId],
      "onUpdate:modelValue": $event => $setup.answer[questionItem.questionList[0].questionId] = $event
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionItem.choiceList, (answerItem, answerIndex) => {
        return _openBlock(), _createBlock(_component_el_checkbox, {
          key: 'answer' + answerIndex,
          label: String.fromCharCode(65 + answerIndex),
          size: "large",
          onChange: $setup.setAnswer
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(String.fromCharCode(65 + answerIndex)) + ". ", 1), _createElementVNode("span", {
            innerHTML: answerItem.choiceText
          }, null, 8, _hoisted_14)]),
          _: 2
        }, 1032, ["label", "onChange"]);
      }), 128))]),
      _: 2
    }, 1032, ["modelValue", "onUpdate:modelValue"])])) : questionItem.questionMethod == 'judge' ? (_openBlock(), _createElementBlock("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionItem.choiceList, (answerItem, answerIndex) => {
      return _openBlock(), _createBlock(_component_el_radio, {
        key: 'answer' + answerIndex,
        modelValue: $setup.answer[questionItem.questionList[0].questionId],
        "onUpdate:modelValue": $event => $setup.answer[questionItem.questionList[0].questionId] = $event,
        label: String.fromCharCode(65 + answerIndex),
        size: "large",
        onChange: $setup.setAnswer
      }, {
        default: _withCtx(() => [answerItem.choiceText == '正确' || answerItem.choiceText == 'True' || answerItem.choiceText == 'true' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          style: {
            "background": "none",
            "border": "none",
            "padding": "0",
            "margin-left": "5px",
            "font-size": "18px"
          },
          color: "#fff",
          icon: $setup.Check,
          size: "large"
        }, null, 8, ["icon"])) : _createCommentVNode("", true), answerItem.choiceText == '错误' || answerItem.choiceText == 'false' || answerItem.choiceText == 'False' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          style: {
            "background": "none",
            "border": "none",
            "padding": "0",
            "margin-left": "5px",
            "font-size": "18px"
          },
          color: "#fff",
          icon: $setup.Close,
          size: "large"
        }, null, 8, ["icon"])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["modelValue", "onUpdate:modelValue", "label", "onChange"]);
    }), 128))])) : _createCommentVNode("", true)]);
  }), 128))])])]);
}